module.exports = __webpack_public_path__ + "img/grid-pinned.890f7a99.png";